export enum ApiErrorCode {
    Unknown = "unknown",
    EntityNotFound = "entityNotFound",
    InvalidStatusChange = "invalidStatusChange",
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    code?: ApiErrorCode;
    errors?: { [key: string]: string[] }
    additionalDetails?: any;
}